<template>
  <div v-loading="loading">
    <el-row :gutter="20" style="margin-left: 0px;">
      <div v-for="(item, index) in deliveryPlatform" :key="index" :class="{ 'border delivery-block hover-color': true, active: item.active }" :style="{ cursor: item.error ? 'not-allowed' : 'pointer', color: item.error ? '#909399' : '#262626', float: 'left' }" @click="selectDelivery(item)">
        <div>{{ item.name }}</div>
        <div style="line-height: 14px">{{ item.amount }}{{ item.error ? item.remarks : "元" }}</div>
      </div>
    </el-row>
    <el-row type="flex" justify="end" style="margin-top: 10px;">
      <el-button type="primary" plain @click="onClose">取 消</el-button>
      <el-button type="primary" @click="sendDelivery">确 认</el-button>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "DeliveryTabZsq",
  props: {
    orderInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
      deliveryPlatform: [],
    };
  },
  mounted() {
    this.getDeliveryPlatformList();
  },
  methods: {
    getDeliveryPlatformList() {
      this.topsAjax.get(`${this.baseUrls.deliveryZsq}/query`, { orderId: this.orderInfo.sid }).then((response) => {
        this.deliveryPlatform = response;
        let underPrice = "";
        for (let i = 0; i < this.deliveryPlatform.length; i++) {
          if (!this.deliveryPlatform[i].error && (underPrice === "" || underPrice > this.deliveryPlatform[i].amount)) {
            underPrice = this.deliveryPlatform[i].amount;
          }
        }
        this.$emit("handleUnderPrice", "zsq", underPrice);
      });
    },
    selectDelivery(item) {
      if (item.error) {
        return;
      }
      if (item.active) {
        item.active = false;
      } else {
        item.active = true;
      }
    },
    sendDelivery() {
      let logistic = "";
      let remark = "";
      for (let i = 0; i < this.deliveryPlatform.length; i++) {
        if (this.deliveryPlatform[i].active) {
          if (logistic.length > 0) {
            logistic += ",";
            remark += ",";
          }
          logistic += this.deliveryPlatform[i].logistic;
          remark += this.deliveryPlatform[i].name + ":" + this.deliveryPlatform[i].amount;
        }
      }
      if (this.deliveryPlatform.length === 0) {
        this.$message({ message: "请选择配送平台", type: "warning" });
        return;
      }
      let params = {
        orderId: this.orderInfo.sid,
        logistic,
        remark,
        priceMark: this.deliveryPlatform[0].priceMark
      };
      this.loading = true;
      this.topsAjax.post(`${this.baseUrls.deliveryZsq}/add`, params).then(() => {
        this.loading = false;
        this.$message({ message: "下单成功", type: "success" });
        this.$emit("handleConfirm");
      });
    },
    onClose() {
      this.$emit("handleClose");
    },
  },
};
</script>

<style lang="scss">
.el-popover__title {
  text-align: center;
}

.input145px {
  .el-input {
    width: 145px !important;
  }
}
</style>
<style lang="scss" scoped>
.el-descriptions-item__content > p {
  color: black;
}

.el-form-item {
  margin-bottom: 0;
}

.el-form-item__content {
  display: block;
}

.delivery-platform-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.remaining-time {
  color: green;
}

.overdue-time {
  color: red;
}

.delivery-block {
  height: 70px;
  width: 180px;
  margin-top: 10px;
  margin-right: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
}

.hover-color:hover {
  /* 鼠标悬停时的样式 */
  background-color: rgba(64, 158, 255, 0.21);
}

.active {
  background-color: rgba(64, 158, 255, 0.21);
}
</style>
